var indentation_default = {
  "indentZero": "gGGrL",
  "indentOne": "fIVVz",
  "indentTwo": "_8bzMu",
  "indentThree": "_5UAd5",
  "indentFour": "WgSho",
  "indentFive": "JI8Q4",
  "indentSix": "_8tLBt"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
